module.exports = __webpack_public_path__ + "assets/2cf5ad251688461a27695d1118c0c94f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/arch-legacy-aqua.svg
 ** module id = 7
 ** module chunks = 0
 **/